import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  offerRecipientsRoot: {
    marginTop: theme.spacing(7),
  },
  gridItem: {
    marginTop: '-12px',
  },
  dateFieldContainer: {
    width: theme.spacing(26.375),
    marginTop: theme.spacing(2),
  },
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  offerRecipientsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  textField: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  startContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  companyDetailRow: {
    display: 'flex',
  },
  name: {
    width: '59.6%',
  },
  awsAccountId: {
    width: '34.5%',
    marginLeft: theme.spacing(3),
  },
  offerRecipientSubHead: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(1.75),
  },
  customEmailMessage: {
    marginTop: theme.spacing(6),
    width: '96%',
    marginBottom: theme.spacing(4.3),
  },
  offerName: {
    width: '96%',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4.3),
  },
  serviceLength: {
    width: theme.spacing(36.375),
    marginTop: theme.spacing(2),
  },

  serviceLengthRow: {
    alignItems: 'flex-start',
  },

  serviceLengthContainer: {
    marginLeft: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
  },
  startDateUpperContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(2),
  },
  startDateLowerContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  dateField: {
    '& .MuiInputLabel-root': {
      marginTop: theme.spacing(-0.5),
    },
  },
  textAlign: {
    textAlign: 'left',
  },
  selectField: {
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  inputLabel: {
    '&.MuiFormLabel-root': {
      fontSize: '12px',
      color: theme.palette.primary.light,
      fontWeight: 600,
      display: 'flex',
    },
    transform: 'translateY(20px) scale(1)',
  },
  menuRoot: {
    '&.MuiMenuItem-root': {
      fontSize: '13px',
      color: theme.palette.headerTitle.main,
    },
    '&.MuiListItem-gutters': {
      padding: theme.spacing(1.5),
    },
    '&.MuiListItem-root.Mui-selected': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
    '&.MuiListItem-button:hover': {
      backgroundColor: theme.palette.selectionBackgroundColor.main,
    },
  },
  icon: {
    '&.MuiSelect-icon': {
      color: theme.palette.text.tertiary,
    },
  },
  selectFormWidth: {
    width: '100%',
    minWidth: '135px',
  },
  preparedBy: {
    marginTop: theme.spacing(2.5),
    width: '59.6%',
  },
}))
